// AUTOGENERATED — do not edit. Source: schemas/modes/memlcelium.json. Run `bun run codegen/generate.ts` to regenerate.
import type { ModeSchema } from './types';

export interface MemlceliumParams {
  readonly seq0_ratio0: number;
  readonly seq0_ratio1: number;
  readonly seq0_ratio2: number;
  readonly seq0_phasor_mul: number;
  readonly seq0_phase_off: number;
  readonly seq0_amp0: number;
  readonly seq0_amp1: number;
  readonly seq1_ratio0: number;
  readonly seq1_ratio1: number;
  readonly seq1_ratio2: number;
  readonly seq1_phasor_mul: number;
  readonly seq1_phase_off: number;
  readonly seq1_amp0: number;
  readonly seq1_amp1: number;
  readonly v0_base_freq: number;
  readonly v0_paf0_cf: number;
  readonly v0_paf1_cf: number;
  readonly v0_paf2_cf: number;
  readonly v0_paf0_bw: number;
  readonly v0_paf1_bw: number;
  readonly v0_paf2_bw: number;
  readonly v0_paf_vib: number;
  readonly v0_paf_vfr: number;
  readonly v0_paf0_shift: number;
  readonly v0_paf1_shift: number;
  readonly v0_paf2_shift: number;
  readonly v0_amp_attack: number;
  readonly v0_amp_decay: number;
  readonly v0_amp_sustain: number;
  readonly v0_amp_release: number;
  readonly v0_pitch_attack: number;
  readonly v0_pitch_decay: number;
  readonly v0_pitch_emph: number;
  readonly v0_shape_gain: number;
  readonly v0_shape_asym: number;
  readonly v0_shape_mix: number;
  readonly v0_rm_gain: number;
  readonly v1_base_freq: number;
  readonly v1_detune1: number;
  readonly v1_detune2: number;
  readonly v1_paf0_cf: number;
  readonly v1_paf1_cf: number;
  readonly v1_paf2_cf: number;
  readonly v1_paf0_bw: number;
  readonly v1_paf1_bw: number;
  readonly v1_paf2_bw: number;
  readonly v1_paf0_shift: number;
  readonly v1_paf1_shift: number;
  readonly v1_paf2_shift: number;
  readonly v1_amp_attack: number;
  readonly v1_amp_decay: number;
  readonly v1_amp_sustain: number;
  readonly v1_amp_release: number;
  readonly v1_pitch_attack: number;
  readonly v1_pitch_decay: number;
  readonly v1_pitch_emph: number;
}

export const MemlceliumSchema: ModeSchema = {
  mode_id: 'memlcelium',
  engine_id: 'memlcelium',
  ml: {
    input_channels: [
      'joy_x',
      'joy_y',
      'joy_z',
      'joy_w',
    ],
    input_size: 4,
    hidden_layers: [
      10,
      14,
      18,
    ],
    output_size: 56,
    default_spread: 0.6,
  },
  params: [
    {
      name: 'seq0_ratio0',
      label: 'Seq0 Ratio 0',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq0_ratio1',
      label: 'Seq0 Ratio 1',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq0_ratio2',
      label: 'Seq0 Ratio 2',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq0_phasor_mul',
      label: 'Seq0 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq0_phase_off',
      label: 'Seq0 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq0_amp0',
      label: 'Seq0 Amp 0',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq0_amp1',
      label: 'Seq0 Amp 1',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq1_ratio0',
      label: 'Seq1 Ratio 0',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq1_ratio1',
      label: 'Seq1 Ratio 1',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq1_ratio2',
      label: 'Seq1 Ratio 2',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq1_phasor_mul',
      label: 'Seq1 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq1_phase_off',
      label: 'Seq1 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq1_amp0',
      label: 'Seq1 Amp 0',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'seq1_amp1',
      label: 'Seq1 Amp 1',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'sequencer',
    },
    {
      name: 'v0_base_freq',
      label: 'V0 Base Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf0_cf',
      label: 'V0 PAF0 CF',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf1_cf',
      label: 'V0 PAF1 CF',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf2_cf',
      label: 'V0 PAF2 CF',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf0_bw',
      label: 'V0 PAF0 BW',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf1_bw',
      label: 'V0 PAF1 BW',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf2_bw',
      label: 'V0 PAF2 BW',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf_vib',
      label: 'V0 PAF Vib',
      min: 0,
      max: 1,
      default: 0,
      curve: 'square',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf_vfr',
      label: 'V0 PAF Vib Rate',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'square',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf0_shift',
      label: 'V0 PAF0 Shift',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf1_shift',
      label: 'V0 PAF1 Shift',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_paf2_shift',
      label: 'V0 PAF2 Shift',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_amp_attack',
      label: 'V0 Amp Attack',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v0_env',
    },
    {
      name: 'v0_amp_decay',
      label: 'V0 Amp Decay',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'v0_env',
    },
    {
      name: 'v0_amp_sustain',
      label: 'V0 Amp Sustain',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v0_env',
    },
    {
      name: 'v0_amp_release',
      label: 'V0 Amp Release',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'v0_env',
    },
    {
      name: 'v0_pitch_attack',
      label: 'V0 Pitch Attack',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v0_env',
    },
    {
      name: 'v0_pitch_decay',
      label: 'V0 Pitch Decay',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'v0_env',
    },
    {
      name: 'v0_pitch_emph',
      label: 'V0 Pitch Emph',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v0_env',
    },
    {
      name: 'v0_shape_gain',
      label: 'V0 Shape Gain',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_shape_asym',
      label: 'V0 Shape Asym',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_shape_mix',
      label: 'V0 Shape Mix',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v0_rm_gain',
      label: 'V0 RingMod Gain',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v0_synth',
    },
    {
      name: 'v1_base_freq',
      label: 'V1 Base Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_detune1',
      label: 'V1 Detune 1',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_detune2',
      label: 'V1 Detune 2',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_paf0_cf',
      label: 'V1 PAF0 CF',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_paf1_cf',
      label: 'V1 PAF1 CF',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_paf2_cf',
      label: 'V1 PAF2 CF',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_paf0_bw',
      label: 'V1 PAF0 BW',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_paf1_bw',
      label: 'V1 PAF1 BW',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_paf2_bw',
      label: 'V1 PAF2 BW',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_paf0_shift',
      label: 'V1 PAF0 Shift',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_paf1_shift',
      label: 'V1 PAF1 Shift',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_paf2_shift',
      label: 'V1 PAF2 Shift',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_synth',
    },
    {
      name: 'v1_amp_attack',
      label: 'V1 Amp Attack',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v1_env',
    },
    {
      name: 'v1_amp_decay',
      label: 'V1 Amp Decay',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'v1_env',
    },
    {
      name: 'v1_amp_sustain',
      label: 'V1 Amp Sustain',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'v1_env',
    },
    {
      name: 'v1_amp_release',
      label: 'V1 Amp Release',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'v1_env',
    },
    {
      name: 'v1_pitch_attack',
      label: 'V1 Pitch Attack',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v1_env',
    },
    {
      name: 'v1_pitch_decay',
      label: 'V1 Pitch Decay',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'v1_env',
    },
    {
      name: 'v1_pitch_emph',
      label: 'V1 Pitch Emph',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'v1_env',
    },
  ],
  voice_spaces: [
    'Direct',
  ],
  curve_overrides: [],
  ui: {
    primary_input: 'xy_pad',
    show_voice_space_selector: false,
    show_synth_visualizer: true,
  },
};
